// extracted by extract-css-chunks-webpack-plugin
module.exports = {"SocialShareCopy":"SocialShareCopy","Tooltip__arrow":"Tooltip__arrow","Tooltip__inner":"Tooltip__inner","SVGIcon":"SVGIcon"};